module.exports = __webpack_public_path__ + "img/music-note-plus.024f5af2.svg";